import PropTypes from 'prop-types';
import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';

// Material ui
import Icon from 'material-ui/Icon';
import Collapse from 'material-ui/transitions/Collapse';

import s from './Fact.css';

class Fact extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    inverse: PropTypes.bool,
    pre: PropTypes.string,
    open: PropTypes.bool,
  };

  static defaultProps = {
    inverse: false,
    pre: '',
    open: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      collapsed: true,
    };

    this.handleClick = this.handleClick.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open) {
      this.setState({
        collapsed: false,
      });
    } else {
      this.setState({
        collapsed: true,
      });
    }
  }

  handleClick = () => {
    const { collapsed } = this.state;

    this.setState({
      collapsed: !collapsed,
    });
  };

  render() {
    const { id, title, children, pre, inverse } = this.props;

    const { collapsed } = this.state;

    return (
      <div
        id={id}
        className={cx(s.root, inverse ? s.inverse : false, 'clearfix')}
      >
        <h2 className={s.title}>
          <button className={s.button} onClick={this.handleClick}>
            {pre ? <span className={s.pre}>{pre}</span> : false}
            {title}
            {collapsed ? <Icon>add_circle</Icon> : <Icon>remove_circle</Icon>}
          </button>
        </h2>
        <Collapse
          in={!collapsed}
          transitionDuration="auto"
          style={{ height: 0, overflow: 'hidden' }}
        >
          <div className={s.content}>{children}</div>
        </Collapse>
      </div>
    );
  }
}

export default withStyles(s)(Fact);



// WEBPACK FOOTER //
// ./src/components/Fact/Fact.js